<template>
    <div>
        <slot name="title">
            <text-header>Банковские реквизиты поставщика</text-header>
        </slot>
        <slot name="info"></slot>
        <text-row :value="supplier_accounting.bank_type.title" compact label="Вид обслуживающей организации" />
        <text-row v-model="supplier_accounting.bik" compact label="БИК банка" />
        <text-row v-model="supplier_accounting.bank_name" compact label="Название банка" />
        <text-row v-model="supplier_accounting.bank_city" compact label="Город банка" />
        <text-row v-model="supplier_accounting.ks" compact label="Кор. счет" />
        <text-row v-model="supplier_accounting.rs" compact label="Расчетный счет" />
        <text-row v-if="supplier_accounting.bank_type !== 'bank'" v-model="supplier_accounting.ls" compact label="Лицевой счет" />
        <text-row v-if="supplier_accounting.bank_type !== 'bank'" v-model="supplier_accounting.fo_inn" compact label="ИНН финансового органа" />
        <text-row v-if="supplier_accounting.bank_type !== 'bank'" v-model="supplier_accounting.fo_name" compact label="Полное наименование финансового органа" />
    </div>
</template>

<script>
export default {
    name: 'text-row-supplier-accounting',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        supplier_accounting: {
            get() {
                return this.value;
            }
        }
    }
};
</script>
